var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_vm._m(0), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Principal"
    }
  }, [_c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição*"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "150",
      "placeholder": "Ex: Produtos para venda ao consumidor final",
      "autofocus": ""
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "NCM"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite o código para pesquisar",
      "label": "codigo",
      "options": _vm.ncms,
      "clearable": true
    },
    on: {
      "input": _vm.setNCM,
      "search": _vm.onSearchNCM
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.ncm,
      callback: function callback($$v) {
        _vm.ncm = $$v;
      },
      expression: "ncm"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do NCM ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEST"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite para pesquisar",
      "filterable": false,
      "options": _vm.cests,
      "clearable": true
    },
    on: {
      "input": _vm.setCEST,
      "search": _vm.onSearchCEST
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cest,
      callback: function callback($$v) {
        _vm.cest = $$v;
      },
      expression: "cest"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CEST ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CFOP NFe"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite para pesquisar",
      "filterable": false,
      "options": _vm.cfops,
      "clearable": true
    },
    on: {
      "input": _vm.setCFOP,
      "search": _vm.onSearchCFOP
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cfop,
      callback: function callback($$v) {
        _vm.cfop = $$v;
      },
      expression: "cfop"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CFOP ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CFOP NFce"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite para pesquisar",
      "filterable": false,
      "options": _vm.cfops_nfce,
      "clearable": true
    },
    on: {
      "input": _vm.setCFOPNFce,
      "search": _vm.onSearchCFOPNfce
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cfop_nfce,
      callback: function callback($$v) {
        _vm.cfop_nfce = $$v;
      },
      expression: "cfop_nfce"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CFOP ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST/CSOSN Não Contribuinte"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite o código",
      "label": "codigo",
      "options": _vm.cstcsosns,
      "clearable": true
    },
    on: {
      "input": _vm.setCSTCSOSN
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cstcsosn,
      callback: function callback($$v) {
        _vm.cstcsosn = $$v;
      },
      expression: "cstcsosn"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST/CSOSN Contribuinte"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite o código",
      "label": "codigo",
      "options": _vm.cstcsosns,
      "clearable": true
    },
    on: {
      "input": _vm.setCSTCSOSNContribuinte
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cstcsosnContribuinte,
      callback: function callback($$v) {
        _vm.cstcsosnContribuinte = $$v;
      },
      expression: "cstcsosnContribuinte"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tributação"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Selecione a tributação",
      "label": "descricao",
      "options": _vm.tributacoes,
      "clearable": true
    },
    on: {
      "input": _vm.setTributacao
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao ? option.descricao.substring(0, 25) : "") + " ")])];
      }
    }]),
    model: {
      value: _vm.tributacao,
      callback: function callback($$v) {
        _vm.tributacao = $$v;
      },
      expression: "tributacao"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Nenhuma tributação disponível ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tributação ST"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Selecione a tributação ST",
      "label": "descricao",
      "options": _vm.tributacoes,
      "clearable": true
    },
    on: {
      "input": _vm.setTributacaoST
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao ? option.descricao.substring(0, 25) : "") + " ")])];
      }
    }]),
    model: {
      value: _vm.tributacaoST,
      callback: function callback($$v) {
        _vm.tributacaoST = $$v;
      },
      expression: "tributacaoST"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Nenhuma tributação disponível ")])], 2)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Origem"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.form.id_origem,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_origem", $$v);
      },
      expression: "form.id_origem"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("Selecione...")]), _vm._l(_vm.origens, function (origem) {
    return _c('b-form-select-option', {
      key: origem.id + 'origem',
      attrs: {
        "value": origem.id
      }
    }, [_vm._v(" " + _vm._s(origem.descricao) + " ")]);
  })], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "mva",
      "label-for": "mva",
      "label": "% MVA"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.mva,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mva", $$v);
      },
      expression: "form.mva"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Código Benef."
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "15",
      "placeholder": "Ex: 2100"
    },
    model: {
      value: _vm.form.codigo_beneficio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigo_beneficio", $$v);
      },
      expression: "form.codigo_beneficio"
    }
  })], 1)], 1), _vm.tributacoes.length > 0 ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "FCP",
      "label-for": "form.id_fcp"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "descricao",
      "options": _vm.tributacoes,
      "clearable": true
    },
    on: {
      "input": _vm.setFCP
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao ? option.descricao.substring(0, 20) : "") + " ")])];
      }
    }], null, false, 90518187),
    model: {
      value: _vm.fcp,
      callback: function callback($$v) {
        _vm.fcp = $$v;
      },
      expression: "fcp"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descricao ")])], 2)], 1)], 1) : _vm._e()], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "IPI/PIS/COFINS"
    }
  }, [_c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', {
    staticClass: "text-dark font-weight-bold mb-3"
  }, [_vm._v("PIS, COFINS e IPI")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "ipi",
      "label-for": "ipi",
      "label": "% IPI"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ipi,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ipi", $$v);
      },
      expression: "form.ipi"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST IPI"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite para pesquisar",
      "filterable": false,
      "options": _vm.cstipis,
      "clearable": true
    },
    on: {
      "input": _vm.setCSTIPI,
      "search": _vm.onSearchCSTIPI
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cstipi,
      callback: function callback($$v) {
        _vm.cstipi = $$v;
      },
      expression: "cstipi"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CST IPI ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "pis",
      "label-for": "pis",
      "label": "% PIS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.pis,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pis", $$v);
      },
      expression: "form.pis"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST PIS"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite para pesquisar",
      "filterable": false,
      "options": _vm.cstspis,
      "clearable": true
    },
    on: {
      "input": _vm.setCSTPIS,
      "search": _vm.onSearchCSTPIS
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cstpis,
      callback: function callback($$v) {
        _vm.cstpis = $$v;
      },
      expression: "cstpis"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CST PIS ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cofins",
      "label-for": "cofins",
      "label": "% COFINS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.cofins,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cofins", $$v);
      },
      expression: "form.cofins"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST COFINS"
    }
  }, [_c('VueSelect', {
    attrs: {
      "placeholder": "Digite para pesquisar",
      "filterable": false,
      "options": _vm.cstscofins,
      "clearable": true
    },
    on: {
      "input": _vm.setCSTCOFINS,
      "search": _vm.onSearchCSTCOFINS
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " ")])];
      }
    }]),
    model: {
      value: _vm.cstcofins,
      callback: function callback($$v) {
        _vm.cstcofins = $$v;
      },
      expression: "cstcofins"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código do CST COFINS ")])], 2)], 1)], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Reforma Tributária"
    }
  }, [_c('b-row', [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Atenção!")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Estamos acompanhando de perto as mudanças da Reforma Tributária e para deixar essa transição mais simples e transparente pra você, incluímos abaixo alguns campos que simulam a nova tributação (IBS/CBS/IS). Esses dados são orientativos e podem mudar conforme novas definições legais forem publicadas. ")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Class. trib. IBS/CBS."
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.optionsClassTribIbsCbsFiltered
    },
    model: {
      value: _vm.form.class_trib_ibs_cbs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "class_trib_ibs_cbs", $$v);
      },
      expression: "form.class_trib_ibs_cbs"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST IBS/CBS"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.optionsCstIbsCbsArr
    },
    model: {
      value: _vm.form.cst_ibs_cbs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cst_ibs_cbs", $$v);
      },
      expression: "form.cst_ibs_cbs"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Class. trib. regular"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.optionsClassTribRegularFiltered
    },
    model: {
      value: _vm.form.class_trib_regular,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "class_trib_regular", $$v);
      },
      expression: "form.class_trib_regular"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST regular"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.optionsCstRegular
    },
    model: {
      value: _vm.form.cst_regular,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cst_regular", $$v);
      },
      expression: "form.cst_regular"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cod. créd. Presumido"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.optionsCodCredPresumido
    },
    model: {
      value: _vm.form.cod_cred_presumido,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cod_cred_presumido", $$v);
      },
      expression: "form.cod_cred_presumido"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-end",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Ind. bem móvel usado"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.ind_bem_movel_usado,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ind_bem_movel_usado", $$v);
      },
      expression: "form.ind_bem_movel_usado"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mt-3 mb-2 text-muted font-weight-bold"
  }, [_vm._v("IBS - Imposto sobre Bens e Serviços")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Redução base Mun."
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ibs_reducao_mun,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ibs_reducao_mun", $$v);
      },
      expression: "form.ibs_reducao_mun"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Aliq efetiva Mun."
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ibs_aliquota_efetiva_mu,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ibs_aliquota_efetiva_mu", $$v);
      },
      expression: "form.ibs_aliquota_efetiva_mu"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Redução base UF"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ibs_reducao_uf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ibs_reducao_uf", $$v);
      },
      expression: "form.ibs_reducao_uf"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Aliq efetiva UF."
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ibs_aliquota_efetiva_uf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ibs_aliquota_efetiva_uf", $$v);
      },
      expression: "form.ibs_aliquota_efetiva_uf"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Diferimento Mun."
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ibs_diferimento_mun,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ibs_diferimento_mun", $$v);
      },
      expression: "form.ibs_diferimento_mun"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Diferimento UF"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.ibs_diferimento_uf,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "ibs_diferimento_uf", $$v);
      },
      expression: "form.ibs_diferimento_uf"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('div', {
    staticClass: "mt-2 mb-2 text-muted font-weight-bold"
  }, [_vm._v("CBS - Contribuição sobre Bens e Serviços")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Diferimento"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.cbs_diferimento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cbs_diferimento", $$v);
      },
      expression: "form.cbs_diferimento"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Redução"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.cbs_reducao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cbs_reducao", $$v);
      },
      expression: "form.cbs_reducao"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Aliq. efetiva CBS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.cbs_aliq_cred_presumido,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cbs_aliq_cred_presumido", $$v);
      },
      expression: "form.cbs_aliq_cred_presumido"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1), _c('div', {
    staticClass: "mt-2 mb-2 text-muted font-weight-bold"
  }, [_vm._v("IS - Imposto Seletivo")]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CST IS"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": true,
      "options": _vm.optionsCstIs
    },
    model: {
      value: _vm.form.cst_is,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cst_is", $$v);
      },
      expression: "form.cst_is"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Class. trib. IS"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": true,
      "options": _vm.optionsClassTribIs
    },
    model: {
      value: _vm.form.class_trib_is,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "class_trib_is", $$v);
      },
      expression: "form.class_trib_is"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Alíquota específica"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.form.aliquota_especifica_is,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliquota_especifica_is", $$v);
      },
      expression: "form.aliquota_especifica_is"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Alíquota IS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.form.aliquota_is,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "aliquota_is", $$v);
      },
      expression: "form.aliquota_is"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_vm.loading ? _c('Loader') : _vm._e(), _c('button', {
    staticClass: "btn btn-primary mr-2",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [!_vm.loading ? _c('i', {
    staticClass: "fa fa-save"
  }) : _vm._e(), _vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-secondary ml-2",
    attrs: {
      "to": "/perfilTributario"
    }
  }, [_vm._v(" Cancelar ")])], 1)])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Perfil Tributário")])]);
}];
export { render, staticRenderFns };